let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eUrPo")).then(() => parcelRequire('eZsOM'));